import { useMutation, useQuery } from "@apollo/client";
import { GetAdminUserResponse } from "../../../redux/types/user-model";
import { GET_ADMIN_USERS } from "../../operation/querys";
import { DELETE_ADMIN } from "../../operation/mutations/mutation";

interface queryInput {
  limit: number;
  offset: number;
  isSkip?: boolean;
}

export const useFetchAdminUser = ({
  limit,
  offset,
  isSkip = false,
}: queryInput) => {
  const { loading, error, data, refetch } = useQuery<
    GetAdminUserResponse,
    queryInput
  >(GET_ADMIN_USERS, {
    variables: { limit, offset },
    skip: isSkip,
  });

  return {
    loading,
    error,
    adminUsersData: data?.adminUsers,
    refetch,
  };
};

export const useDeleteAdmin = () => {
  const [deleteAdminMutation, { loading, error, data }] = useMutation<
    { deleteAdmin: boolean },
    { id: number }
  >(DELETE_ADMIN);

  const deleteAdmin = async (id: number) => {
    return await deleteAdminMutation({
      variables: { id },
    });
  };

  return {
    deleteAdmin,
    loading,
    error,
    data,
  };
};
